<script lang="ts">
  import ChoiceList from '../lib/ui/ChoiceList.svelte';
  import Field from '../lib/ui/Field.svelte';
  import type { ReportDefinitionTenant } from '../lib/api';
  import type { TenantSearch } from '../lib/tenant-search.svelte';

  interface Props {
    search: TenantSearch;
    chosen: ReportDefinitionTenant | null;
    onChoose: (tenant: ReportDefinitionTenant) => void;
    isDisabled: (tenant: ReportDefinitionTenant) => boolean;
    disabledNote: string;
  }

  let { search, chosen, onChoose, isDisabled, disabledNote }: Props = $props();

  let end = $state<HTMLElement | undefined>();

  /** Refeito a cada página: o observer só avisa quando a visibilidade muda, e numa tela alta o fim segue visível. */
  $effect(() => {
    if (!end || !search.results().length) return;
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting) && search.hasMore) search.showMore();
    });
    observer.observe(end);
    return () => observer.disconnect();
  });
</script>

<Field label="Cliente" hint="Só clientes ativos · a lista carrega mais ao rolar">
  <input
    type="search"
    placeholder="Buscar pelo nome"
    value={search.term}
    oninput={(event) => search.searchFor(event.currentTarget.value)}
  />
</Field>
<ChoiceList
  name="tenant"
  items={search.results()}
  key={(tenant) => tenant.tenantId}
  isChosen={(tenant) => tenant.tenantId === chosen?.tenantId}
  {isDisabled}
  title={(tenant) => tenant.name}
  subtitle={(tenant) => (isDisabled(tenant) ? disabledNote : '')}
  emptyText={search.hasNoMatch ? 'Nenhum cliente com esse nome.' : ''}
  {onChoose}
/>
<div bind:this={end} aria-hidden="true"></div>
